<div class="container">
    <div class="row">
        <div class="col-md-2 breadcrumb-container flex-20">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="col-md-10 options-container flex-80">
            <app-your-options-calculation (emittedPageMode)="getEmittedPageMode($event)" [editFlag]="editFlag" 
            [cardNumber]="cardNumber" [productChoiceData]="productChoiceData">
            </app-your-options-calculation>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <app-quote-calculation-result (emittedCardNumber)="getEmittedCardNumber($event)" (editFlagEmitter)="getEditFlag($event)"
            [changeCard]="changeCard" [productChoiceData]="productChoiceData"> </app-quote-calculation-result>
        </div>
    </div>
    <app-modal *ngIf="requoteLTAFlag" [modalConfig]="requoteLTAModalConfig" (primaryBtnClick)="closeLTARequoteModal()"
    (closeModal)="closeLTARequoteModal()" [saveDataFlag]="false">
    </app-modal>
     <!-- <div class="col-md-12 col-sm-12 clear-all">
        <div class="col-md-2 test-cont margin-top-10 ">
                <div class="row dummy"></div>
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="col-md-10 col-sm-12 clear-all width-78 margin-left">
            <app-your-options-calculation (emittedPageMode)="getEmittedPageMode($event)" [editFlag]="editFlag" 
            [cardNumber]="cardNumber" [productChoiceData]="productChoiceData">
            </app-your-options-calculation>
        </div>
    </div>
    <div class="col-md-12 clear-all">
        <app-quote-calculation-result (emittedCardNumber)="getEmittedCardNumber($event)" (editFlagEmitter)="getEditFlag($event)"
            [changeCard]="changeCard" [productChoiceData]="productChoiceData"> </app-quote-calculation-result>
    </div>
    <app-modal *ngIf="requoteLTAFlag" [modalConfig]="requoteLTAModalConfig" (primaryBtnClick)="closeLTARequoteModal()"
   (closeModal)="closeLTARequoteModal()" [saveDataFlag]="false">
  </app-modal> -->
</div>